import { Maestro_Productos } from "./Maestro_Productos";
import { Maestro_ProductosCampos } from "./Maestro_ProductosCampos";
import { Maestro_ProductosCamposBeneficiarios } from "./Maestro_ProductosCamposBeneficiarios";
import { Maestro_ProductosCodigosActivacion } from "./Maestro_ProductosCodigosActivacion";
import { Maestro_ProductosEdades } from "./Maestro_ProductosEdades";
import { Maestro_ProductosEstadosDias } from "./Maestro_ProductosEstadosDias";
import { Maestro_ProductosExpedientes } from "./Maestro_ProductosExpedientes";
import { Maestro_ProductosFirmaElectronica } from "./Maestro_ProductosFirmaElectronica";
import { Maestro_ProductosNotificaciones } from "./Maestro_ProductosNotificaciones";
import { Maestro_ProductosPlazos } from "./Maestro_ProductosPlazos";

export class Maestro_Productos_Actualizacion {
    principal: Maestro_Productos;
    codigoComercializacion: string;
    listaPlazos: Maestro_ProductosPlazos[];
    listaPlazosEliminar: Maestro_ProductosPlazos[];
    listaEdades: Maestro_ProductosEdades[];
    listaEdadesEliminar: Maestro_ProductosEdades[];
    listaFirmaElectronica: Maestro_ProductosFirmaElectronica[];
    listaFirmaElectronicaEliminar: Maestro_ProductosFirmaElectronica[];
    listaCodigosActivacion: Maestro_ProductosCodigosActivacion[];
    listaCodigosActivacionEliminar: Maestro_ProductosCodigosActivacion[];
    listaExpedientes: Maestro_ProductosExpedientes[];
    listaExpedientesEliminar: Maestro_ProductosExpedientes[];
    listaEstadosDias: Maestro_ProductosEstadosDias[];
    listaEstadosDiasEliminar: Maestro_ProductosEstadosDias[];
    listaCampos: Maestro_ProductosCampos[];
    listaCamposEliminar: Maestro_ProductosCampos[];
    listaCamposBeneficiarios: Maestro_ProductosCamposBeneficiarios[];
    listaCamposBeneficiariosEliminar: Maestro_ProductosCamposBeneficiarios[];
    listaNotificaciones: Maestro_ProductosNotificaciones[];
    listaNotificacionesEliminar: Maestro_ProductosNotificaciones[];
}